import { I18n } from '@calendly/i18n';
import { FC } from 'react';
const badgeCss = "b1vcv6i0";
const dotCss = "djm8jv";
export interface SSEConnectionBadgeProps {
  /** Current SSE connection state: 'connected' | 'connecting' | 'error' | etc. */
  connectionState?: string | null;
  /** When false, the badge is not rendered. Use with feature flag so badge only shows when realtime SSE is enabled. */
  isVisible?: boolean;
}
const getLabel = (connectionState: string) => {
  switch (connectionState) {
    case 'connected':
      return I18n.t('publisher.meetings.meetings_realtime.sse_badge.connected');
    case 'error':
      return I18n.t('publisher.meetings.meetings_realtime.sse_badge.disconnected');
    default:
      return I18n.t('publisher.meetings.meetings_realtime.sse_badge.connecting');
  }
};
const getState = (connectionState: string) => {
  switch (connectionState) {
    case 'connected':
      return 'connected';
    case 'error':
      return 'error';
    default:
      return 'other';
  }
};

/**
 * Badge showing realtime SSE connection state (Connected / Connecting… / Disconnected).
 * Shared by Meetings Realtime and the meetings list page for debugging when SSE is enabled.
 * Only render when the realtime SSE feature flag is on by passing isVisible={isRealtimeSSEEnabled}.
 */
export const SSEConnectionBadge: FC<SSEConnectionBadgeProps> = ({
  connectionState,
  isVisible = true
}) => {
  if (!isVisible || connectionState == null) {
    return null;
  }
  const state = getState(connectionState);
  const label = getLabel(connectionState);
  return <span data-testid="realtime-sse-connection-badge" data-state={state} className={badgeCss} aria-live="polite">
      <span data-state={state} className={dotCss} aria-hidden />
      {label}
    </span>;
};

require("./SSEConnectionBadge.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SSEConnectionBadge.tsx");